/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Record_All_EventsInputs */

const th_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติ · ทุกกิจกรรม`)
};

const en_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record · all events`)
};

const ja_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成績 · 全イベント`)
};

const zh_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`战绩 · 全部赛事`)
};

const es_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance · todos los eventos`)
};

const pt_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campanha · todos os eventos`)
};

const id_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekor · semua acara`)
};

const fr_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilan · tous les événements`)
};

const tl_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekord · lahat ng event`)
};

const vi_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích · mọi sự kiện`)
};

const ko_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전적 · 전체 이벤트`)
};

const de_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilanz · alle Events`)
};

const ru_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Баланс · все события`)
};

const tr_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilanço · tüm etkinlikler`)
};

const it_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilancio · tutti gli eventi`)
};

const pl_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilans · wszystkie wydarzenia`)
};

const uk_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Баланс · усі події`)
};

const hi_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड · सभी आयोजन`)
};

const ar_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السجل · كل الفعاليات`)
};

const ms_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekod · semua acara`)
};

const bn_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেকর্ড · সব আয়োজন`)
};

const zh_tw2_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戰績 · 所有賽事`)
};

const zh_hk2_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戰績 · 所有賽事`)
};

const ur_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ریکارڈ · تمام ایونٹ`)
};

const fa_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کارنامه · همهٔ رویدادها`)
};

const sw_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekodi · matukio yote`)
};

const nl_record_all_events = /** @type {(inputs: Record_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balans · alle evenementen`)
};

/**
* | output |
* | --- |
* | "Record · all events" |
*
* @param {Record_All_EventsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const record_all_events = /** @type {((inputs?: Record_All_EventsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Record_All_EventsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_record_all_events(inputs)
	if (locale === "ja") return ja_record_all_events(inputs)
	if (locale === "zh") return zh_record_all_events(inputs)
	if (locale === "es") return es_record_all_events(inputs)
	if (locale === "pt") return pt_record_all_events(inputs)
	if (locale === "id") return id_record_all_events(inputs)
	if (locale === "fr") return fr_record_all_events(inputs)
	if (locale === "tl") return tl_record_all_events(inputs)
	if (locale === "vi") return vi_record_all_events(inputs)
	if (locale === "ko") return ko_record_all_events(inputs)
	if (locale === "de") return de_record_all_events(inputs)
	if (locale === "ru") return ru_record_all_events(inputs)
	if (locale === "tr") return tr_record_all_events(inputs)
	if (locale === "it") return it_record_all_events(inputs)
	if (locale === "pl") return pl_record_all_events(inputs)
	if (locale === "uk") return uk_record_all_events(inputs)
	if (locale === "hi") return hi_record_all_events(inputs)
	if (locale === "ar") return ar_record_all_events(inputs)
	if (locale === "ms") return ms_record_all_events(inputs)
	if (locale === "bn") return bn_record_all_events(inputs)
	if (locale === "zh-TW") return zh_tw2_record_all_events(inputs)
	if (locale === "zh-HK") return zh_hk2_record_all_events(inputs)
	if (locale === "ur") return ur_record_all_events(inputs)
	if (locale === "fa") return fa_record_all_events(inputs)
	if (locale === "sw") return sw_record_all_events(inputs)
	if (locale === "nl") return nl_record_all_events(inputs)
	return en_record_all_events(inputs)
});